export const convertPhotosData = (data = []) => {
  return data.map(({ id, srcset, alt = '' }) => {
    return {
      id,
      src: srcset?.[0]?.url,
      alt
    };
  });
};
